import { render, staticRenderFns } from "./FeaturedEntry.vue?vue&type=template&id=7841d54e&"
import script from "./FeaturedEntry.vue?vue&type=script&lang=js&"
export * from "./FeaturedEntry.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedEntry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports